import styled from "styled-components";

export const OrangeCircle = styled.div`
  width: 15px; /* 지름 설정 */
  height: 15px; /* 지름 설정 */
  background-color: #FF7A00;
  display: inline-block;
  margin-right: 7px;
  align-items: center;
  border-radius: 50%; /* 원 모양으로 만들기 */
`;